export const DEFAULT_ROW_STULES = {
  borderTop: '1px',
  borderLeft: '1px',
  borderColor: 'gray.200',
  p: '2',
  textAlign: 'center',
};
